import React, { useContext, useState } from "react";
import { ErrorOutline } from "@mui/icons-material";
import { isPast } from "date-fns";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ACTION_TYPE, ACTION_ITEM_COLUMN } from "./constants";
import { setSelectedFollowUp } from "../../../../cm/Dashboard/FullPages/ClientDetail/FollowUps/Calendar/state/actions";
import { FollowUpModalDispatchContext } from "../context/FollowUpModalContext";
import { CONTENT_VIEW_FOLLOWUP } from "../../../../cm/Dashboard/FullPages/ClientDetail/FollowUps/FollowUpModal/components/modalcontent/HistoryListView/state/actions";
import {
  CONTENT_EDIT_FOLLOWUP,
  setCaseInfo,
  showContent,
  toggleDialog,
} from "../state/actions";
import { STATUS_TYPES } from "../../../../cm/Dashboard/FullPages/ClientDetail/FollowUps/CaseFollowUps/components/types/statusTypes";
import FormatISODate from "../../../../global/FormatISODate";
import { EventsDispatchContext } from "../../../../../context/EventsProvider";
import { setFollowUpIdForCallTracking } from "../../../../../../state/actions";
import Colors from "../../../../global/Colors";

export default function ActionItem({
  item,
  columnType,
  setActiveActionItem,
  openAddActionItemModal,
}) {
  /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
  const globalEventDispatch = useContext(EventsDispatchContext);
  const followUpModalDispatch = useContext(FollowUpModalDispatchContext);
  /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
  const navigate = useNavigate();

  const valueFallback = (value, fallbackString) => {
    if (!value) return fallbackString;

    return value;
  };
  const getLabel = () => {
    if (parseInt(columnType) === ACTION_TYPE.MANUAL)
      return valueFallback(item?.actingUser?.name, "No Acting User Name");
    if (parseInt(columnType) === ACTION_TYPE.CLIENT_FOLLOW_UP)
      return valueFallback(item?.onCase?.client?.name, "No Client Name");
    if (parseInt(columnType) === ACTION_TYPE.LAW_FIRM_FOLLOW_UP)
      return valueFallback(item?.onFirm?.name, "No Law Firm Name");
    if (parseInt(columnType) === ACTION_TYPE.PROVIDER_FOLLOW_UP)
      return valueFallback(item?.onProvider?.name, "No ProviderName");
  };

  const getFollowUpFormRoute = () => {
    return "/follow-ups/" + item?.id;
  };

  const getBgColor = (colorShade, defaultColor = "white") => {
    return item?.priority > 0 || item?.priorityDate
      ? Colors.blue[colorShade]
      : Colors[defaultColor];
  };

  /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
  const setSelectedFollowUpForModal = () => {
    setCaseInfo(followUpModalDispatch, {
      clientId: item?.onCase?.client?.id,
      caseId: item?.onCase?.id,
      lawFirmId: item?.onFirm?.id,
    });
    //this method sets state for the follow up modal. it is not necessary after route follow up forms are done and can be removed later.
    setSelectedFollowUp(followUpModalDispatch, {
      id: item?.id,
      clock: null,
      label: getLabel(),
      timeTillDueDate: item?.relativeDueDate,
      status: item?.status,
      actionType: item?.actionType,
      completedBy: item?.completedBy,
      completedAt: item?.completedAt,
      updatedBy: item?.updatedBy,
      updatedAt: item?.updatedAt,
      fields: {
        dueDate: item?.dueDate,
        detail: item?.actionDetail,
        ...(parseInt(columnType) === ACTION_TYPE.PROVIDER_FOLLOW_UP
          ? { provider: item?.onProvider }
          : {}),
      },
      client: item.onCase.client,
      ...(parseInt(columnType) === ACTION_TYPE.LAW_FIRM_FOLLOW_UP
        ? { lawFirm: item.onFirm }
        : {}),
    });
    let dialogContent = CONTENT_VIEW_FOLLOWUP;

    if (item?.status === STATUS_TYPES.PENDING) {
      dialogContent = CONTENT_EDIT_FOLLOWUP;
    }
    showContent(followUpModalDispatch, dialogContent);
    toggleDialog(followUpModalDispatch, true);
  };
  /* TEMPORARY MODAL END - only until form navigation is ready. can remove later */

  const clickHandler = () => {
    if (parseInt(columnType) === ACTION_ITEM_COLUMN) {
      if (setActiveActionItem) {
        setActiveActionItem(item);
      }

      openAddActionItemModal();
    } else {
      /* TEMPORARY MODAL BEGIN - only until form navigation is ready. can remove later */
      setSelectedFollowUpForModal();
      dialClient(getPhoneNumber());
      setFollowUpIdForCallTracking(globalEventDispatch, item?.id);
      /* TEMPORARY MODAL END - only until form navigation is ready. can remove later */

      //UNCOMMENT TO ROUTE TO NEW FORMS navigate(getFollowUpFormRoute());
    }
  };
  const getPhoneNumber = () => {
    if (parseInt(columnType) === ACTION_TYPE.CLIENT_FOLLOW_UP) {
      return item?.onCase?.client?.phone;
    }
    if (parseInt(columnType) === ACTION_TYPE.PROVIDER_FOLLOW_UP) {
      return item?.onProvider?.phone;
    }
    if (parseInt(columnType) === ACTION_TYPE.LAW_FIRM_FOLLOW_UP) {
      return item?.onFirm?.phone;
    }
    return "";
  };
  const dialClient = (number) => {
    const widgetToggle = document.querySelector(".Adapter_toggle");
    const widgetContainer = document.querySelector(".Adapter_root");
    if (widgetContainer.classList.contains("Adapter_minimized")) {
      widgetToggle.click();
    }

    document
      .querySelector("#rc-widget-adapter-frame")
      .contentWindow.postMessage(
        {
          type: "#rc-widget-adapter-frame",
          phoneNumber: number,
          toDial: false,
          conversation: false, // will go to conversation page if conversation existed
        },
        "*"
      );
  };

  return (
    <div className="border-b-2 mb-2">
      <div
        className={`w-full h-[70px] rounded-md  p-2 mb-2 hover:bg-blue-200`}
        style={{
          backgroundColor: getBgColor(100),
        }}
        onClick={() => clickHandler()}
      >
        <div
          className="flex w-full h-1/3 capitalize text-xs font-bold"
          style={{
            color: getBgColor(800, "black"),
          }}
        >
          <div className="w-[90%]">{getLabel()}</div>
          <div className="w-[10%] text-right">
            {isPast(new Date(item?.dueDate)) && (
              <Tooltip title={"This item is past the due date!"}>
                <ErrorOutline className="text-[1rem] text-red-600" />
              </Tooltip>
            )}
          </div>
        </div>
        <div
          className="w-full h-1/3 capitalize text-xs"
          style={{
            color: getBgColor(800, "black"),
          }}
        >
          <div className="truncate text-ellipsis mb-1">
            {item?.actionDetail ? item?.actionDetail : "No Description"}
          </div>
          <div className="text-xs">
            <span className="font-bold">DUE: </span>
            {item?.dueDate ? (
              <span className="lowercase">
                {FormatISODate(item?.dueDate)}{" "}
                {"(" + item?.relativeDueDate + ")"}
              </span>
            ) : (
              "No Due Date Available"
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
